import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// import Applauses from '../components/Applauses';
import CertificateFAPage from '../../components/CertificateFAPage';
import MainLayout from '../../layouts/MainLayout';
import logo from '../../assets/logo.svg';

const MyApplauseCertificates = () => {

  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);



  return (
      <MainLayout>
          <div className='bg-primary text-white h-[100vh] py-8 text-center'>
                        <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>My Applauses Certificate List</h3>
            <div className='text-5xl mt-1 mx-8 text-pink-500'><CertificateFAPage>{}</CertificateFAPage></div>
           </div>
      </MainLayout>
  )
}

export default MyApplauseCertificates